function Schedule() {
  return (
    <section className="py-16 px-6 bg-gray-50">
      <div className="max-w-5xl mx-auto">

        <h1 className="text-4xl font-bold text-blue-900 mb-10 text-center">
          School Schedule
        </h1>

        <div className="bg-white p-8 rounded-2xl shadow space-y-6 text-gray-700">

          <p>
            <strong>Grade I and above:</strong> 9:30 AM – 3:30 PM
          </p>

          <p>
            <strong>Pre-primary:</strong> 9:30 AM – 12:30 PM
          </p>

          <p>
            Students must reach before <strong>9:15 AM</strong>. Gates close at <strong>9:20 AM</strong>.
          </p>

          <p>
            Parents can meet teachers only with prior appointment through coordinator.
          </p>

        </div>

      </div>
    </section>
  );
}

export default Schedule;